"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const CardName_1 = require("@/common/cards/CardName");
const Resource_1 = require("@/common/Resource");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'CardExtraContent',
    props: {
        card: {
            type: Object,
            required: true,
        },
    },
    methods: {
        isMiningTileOnSteel() {
            return this.card.name !== CardName_1.CardName.SPECIALIZED_SETTLEMENT && this.card.bonusResource?.includes(Resource_1.Resource.STEEL);
        },
        isMiningTileOnTitanium() {
            return this.card.name !== CardName_1.CardName.SPECIALIZED_SETTLEMENT && this.card.bonusResource?.includes(Resource_1.Resource.TITANIUM);
        },
        lifeFound() {
            return this.card.name === CardName_1.CardName.SEARCH_FOR_LIFE && this.card.resources !== undefined && this.card.resources > 0;
        },
    },
});
